
import AppHeader from '@/components/Header.vue'
import { defineComponent, computed, ref, getCurrentInstance, onMounted, reactive } from 'vue'
import { Icon, PullRefresh, Toast, Dialog } from 'vant'
import { checkRepairOrderDetail, getImageUrlByUuid } from '@/apis/service'
import { useStore } from 'vuex'
export default defineComponent({
  name: 'CheckDetail',
  components: {
    AppHeader,
    vanPullRefresh: PullRefresh,
  },
  setup() {
    const loading = ref(false)
    const { proxy } = getCurrentInstance()
    const imageList = ref([])
    const remark = ref('')
    const store = useStore() // vuestore
    const pagePaddingTop = computed(() => store.getters.pagePaddingTop)
    const onRefresh = async () => {
      await init()
      loading.value = false
    }
    const init = async () => {
      let uids = []
      let param = {
        guid: proxy.$route.params.guid,
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result: any = await checkRepairOrderDetail(param)
        toast.clear()
        remark.value = result.remark
        uids = result.images
      } catch (error: any) {
        let message = error && error.message ? error.message : '获取检测情况失败'
        toast.clear()
        Toast(message)
      }
      if (uids.length >= 1) {
        toast.open({})
        try {
          let uidResult: any = await getImageUrlByUuid({ res_uids: uids })
          imageList.value = uidResult
          toast.clear()
        } catch (error: any) {
          let message = error && error.message ? error.message : '获取图片信息失败'
          toast.clear()
          Toast(message)
        }
      }
    }
    onMounted(() => {
      init()
    })
    return {
      loading,
      imageList,
      remark,
      pagePaddingTop,
      onRefresh,
    }
  },
})
